import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { HeaderModel } from "src/app/_component/header/header.model";
import { UserService } from "src/app/_services";
import { HeaderService } from "src/app/_services/header.service";
import { SpaceType } from "src/app/_types/space-type";

@Component({
  selector: "app-desk",
  templateUrl: "./desk.page.html",
  styleUrls: ["./desk.page.scss"],
})
export class DeskPage implements OnInit {
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private translateService: TranslateService,
    private userService: UserService,
    private headerServ: HeaderService,
  ) {}

  page: string;
  defaultPage: string = "desk_my_reservations";
  segmentsArray = [];
  activeSegment: string;

  spaceType: SpaceType = SpaceType.Desk;

  headerInit: HeaderModel = {
    title: this.translateService.instant("SPACE.DESK.DESKS"),
    userSettingsBreakpoint: 1250,
    segmentsChangeFunc: ($event) => this.segmentChanged($event),
    segments: [
      {
        name: "SPACE.DESK.MY_RESERVATIONS",
        value: "desk_my_reservations",
        permissionKeys: ["desk.segment.reservations-view"],
      },
      {
        name: "SPACE.DESK.ALL_RESERVATIONS",
        value: "desk_all_reservations",
        permissionKeys: ["desk.segment.reservation-all"],
      },
      {
        name: "SPACE.DESK.ALL_AVALIABLE_DESKS",
        value: "desk_space",
        permissionKeys: ["desk.segment.spaces"],
      },
    ],
  };

  segmentChanged($event) {
    this.setQueryParam($event.detail.value);
  }

  setQueryParam(value) {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { section: value },
      queryParamsHandling: "merge", // remove to replace all query params by provided
    });
  }

  async ngOnInit() {
    await this.userService.getPermision();

    this.headerInit.segments.forEach((segment) => {
      if (this.userService.hasRoles(segment.permissionKeys)) {
        this.segmentsArray.push(segment.value);
      }
    });
    
    this.activatedRoute.queryParamMap.subscribe((params) => {
      if (params.get("section")) {
        this.page = params.get("section");
        
        if (this.segmentsArray.filter((el) => el == this.page).length > 0) {
          this.activeSegment = this.page;
        } else {
          this.activeSegment = this.segmentsArray[0];
          this.setQueryParam(this.segmentsArray[0]);
        }
      } else {
        // poniższe asynchroniczne ładowanie odpalane jest po kliknięciu na element głównego menu, żeby zapytanie się wysyłało
        setTimeout(() => {
          this.activeSegment = this.segmentsArray[0];
          this.setQueryParam(this.segmentsArray[0]);
        }, 0);
        this.headerServ.setHeaderInit(this.headerInit);
      }
    });
  }
  
  ionViewWillEnter() {
    this.headerInit.activeSegment = this.activeSegment;
    this.headerServ.setHeaderInit(this.headerInit);
  }

  ionViewDidLeave() {
    this.page = null;
  }
}
